<div class="scan-content" *ngIf="!regret">
  <div class="bar-group">
    <img [src]="getQrCodeUrl()" loading="lazy" />
    <div class="serial">## ## ###</div>
  </div>
  <a>Edit your info</a>
</div>
<div class="display-info">
  <ngx-editor
    [height]="325"
    [borderRadius]="'4px'"
    [placeholder]="'Click here to edit'"
    [message]="message.value"
    (blurred)="EditorOnBlur($event)"
    (valueChange)="update('message', $event)"
  ></ngx-editor>
</div>

<div class="component-card" *ngIf="!regret">
  <div class="card-icon-wrapper">
    <img src="https://res.cloudinary.com/contactless/image/upload/f_png/v1597925268/mail-assets/timings.svg" alt="Event timings" />
  </div>
  <div class="card-body-wrapper" *ngIf="hasEventTimingPreview(); else defaultTimingTemplate">
    <div class="card-content-wrapper">
      <div class="card-title">
        {{ getDisplayDate(event.public_start_date) }}
        <span class="card-title-separator"> - </span>
        <ng-container *ngIf="event.public_end_date; else noPublicEndDate">{{ getDisplayDate(event.public_end_date) }}</ng-container>
        <ng-template #noPublicEndDate><span class="infinite-end" title="No end date" aria-label="No end date">∞</span></ng-template>
      </div>
      <div class="timings">
        <div class="date-row">
          <span class="item" style="width: 45px">
            {{ getDay(event.event_timing[0].day) }}
          </span>
          <span class="item" style="width: 50px"> {{ getDisplayDate(event.event_timing[0].day) }} </span>
          <span class="item timing-range">
            {{ event.event_timing[0].start_datetime }}
            <ng-container *ngIf="event.event_timing[0].end_datetime"> - {{ event.event_timing[0].end_datetime }} </ng-container>
          </span>
          <span class="info">
            {{ event.event_timing[0].info }}
          </span>
        </div>
        <div class="add-calendar">
          <a class="add-btn">Add to Calendar</a>
        </div>
      </div>
    </div>
  </div>
  <ng-template #defaultTimingTemplate>
    <div class="card-body-wrapper">
      <div class="card-content-wrapper">
        <div class="card-title">## ## ## - ## ## ##</div>
        <div class="timings">
          <div class="date-row">
            <span class="item" style="width: 45px"> ## </span>
            <span class="item" style="width: 50px"> ## </span>
            <span class="item" style="width: 82px"> ## - ## </span>
            <span class="info"> </span>
          </div>
          <div class="add-calendar">
            <a class="add-btn">Add to Calendar</a>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</div>
